import { createSelector } from 'reselect';

import { hasUserSelector } from '@xingternal/platform-layout-selectors';

import { navigationItemsSelector } from './navigationItemsSelector';

const navListSelector = createSelector(
  hasUserSelector,
  navigationItemsSelector,
  (hasUser, navigationItems) => ({
    hasUser,
    navigationItems,
  })
);

export { navListSelector };
